import React from "react"
import "../components.css";

export default function TextEntry ({ width = "25vw", height = "25vh", onChange, rows = 1, placeholder = "Enter Text Here", label = "Text", numberOnly = false}: {width?: string, height?: string, onChange: Function, rows?: number, placeholder?: string, label: string, numberOnly?: boolean, limit?: number}) {
    const [isFocused, setIsFocused] = React.useState(false)
    const [value, setValue] = React.useState("")

    React.useEffect(() => {
        console.log("created")
    }, [])

    const tileStyle = {
        width: width,
        height: height,
    }

    function change(text: string) {
        console.log(text)
        onChange(text);
        setValue(text)
    }

    if (rows === 1) {
        return (
            // <div className="tile" style={tileStyle}>
            //     <div className="flex flex-col justify-around h-screen p-5">
            //         <h1 className="font-bold mb-2 whitespace-nowrap">
            //             {label}
            //         </h1>
            //         <div className="w-full h-full">
            //             <input
            //             onChange={(e) => change(e.target.value)}
            //             placeholder={placeholder}
            //             className="w-full h-full text-base overflow-hidden  text-black min-h-[100px] p-3 rounded-lg border border-gray-300 resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            //             type={numberOnly ? "number" : "text"}
            //             />
            //         </div>
            //     </div>
            // </div>
            <div className="flex items-center justify-center" style={tileStyle}>
                <div className="relative w-full h-full">
                    <input 
                    className="w-full h-full rounded-md border border-gray-300 bg-transparent px-4 py-3 text-white text-lg placeholder-transparent focus:outline-none focus:ring-2 focus:ring-gray-300"
                    placeholder={placeholder}
                    onChange={(e) => change(e.target.value)}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    type={numberOnly ? "number" : "text"}
                    />
                    <label
                    className={`absolute left-4 transition-all pointer-events-none
                    ${isFocused || value ? "-top-3.5 bg-black px-1 text-s" : "top-3 text-lg "}
                    peer-placeholder-shown:top-2 peer-placeholder-shown:text-lg
                    peer-focus:-top-3.5 peer-focus:bg-white peer-focus:px-1 peer-focus:text-sm`}
                    >
                    {label}
                </label>
                </div>
            </div>
        )
    }
    
    return (
        <div className="tile" style={tileStyle}>
            <div className="flex flex-col justify-around h-screen p-5">
                <h1 className="font-bold mb-4">
                    {label}
                </h1>
                <div className="w-full h-full">
                    <textarea
                    onChange={(e) => change(e.target.value)}
                    placeholder={placeholder}
                    className="w-full h-full text-base overflow-hidden  text-black min-h-[100px] p-3 rounded-lg border border-gray-300 resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    rows={rows}
                    />
                </div>
            </div>
        </div>
    )
}